import { useMutation } from '@tanstack/react-query'
import { updateUserDetails } from 'api/auth'

type UserUpdateVariables = Pick<App.AuthAccount, 'title' | 'givenName' | 'surname' | 'dob' | 'postcode' | 'phonePrefix' | 'phone'>

interface Params {
  onSuccess?: (data: Partial<App.AuthAccount>) => void
}

function useUserUpdateMutation(params: Params) {
  const registrationMutation = useMutation<Partial<App.AuthAccount>, App.ApiCallFailure, UserUpdateVariables>({
    mutationFn: (variables) => updateUserDetails(variables),
    onSuccess: params.onSuccess,
  })

  return registrationMutation
}

export default useUserUpdateMutation
